module.exports = __webpack_public_path__ + "static/media/09.55c5621a.jpg";